export default "__VITE_ASSET__DFZbuZ_v__"